import { CommonHttp } from "@/models/interfaces/http/common.http.request";


export class AnalyticsApi {
  static getLists(
    filter: string,
    offset: number,
    segment: number,
    elementId: number,
  ): Promise<any> {
    const http = new CommonHttp();
    return http
      .get(
        `Analytics/Lists?filter=${filter}&count=30&offset=${0}&segment=${segment}&elementId=${elementId}`,
      )
      .then((data) => data.data);
  }

  static getList(
    filter: string,
    offset: number,
    segment: number,
    elementId: number,
  ): Promise<any> {
    const http = new CommonHttp();
    return http
      .get(
        `Analytics/Lists?segment=${segment}&filter=${filter}&count=${40}&offset=${0}&listIdToExclude=`,
      )
      .then((data) => data.data);
  }

  static getListOfElement(
    elementId: number,
    segment: number,
  ): Promise<any> {
    const http = new CommonHttp();
    return http
      .get(
        `Analytics/Lists/OfElement/${elementId}?segment=${segment}`,
      )
      .then((data) => data.data);
  }

  // static getListForAdd(filter: string, offset: number, segment: number, elementId: number):  Promise<any> {
  //     const store = rootStore();
  //     const http = new CommonHttp()
  //     return http
  //         .get(`Analytics/Lists?filter=${filter}&count=30&offset=${0}&segment=${segment}&elementId=${elementId}`)
  //         .then(data => data.data)
  // }

  static addElementToList(
    listId: number,
    newListName: string,
    segment: number,
    elementId: number,
  ): Promise<any> {
    const http = new CommonHttp();
    return http
      .put(`Analytics/Lists/AddElement`, {
        listId: listId,
        newListName: newListName,
        elementId: elementId,
        segment: segment,
      })
      .then((data) => data.data);
  }

  static removeElementIntoList(
    listId: number,
    segment: number,
    elementId: number,
  ): Promise<any> {
    const http = new CommonHttp();
    return http
      .post(`Analytics/Lists/RemoveElement`, {
        listId: listId,
        elementId: elementId,
        segment: segment,
      })
      .then((data) => data.data);
  }

  static createList(
    elementId: number,
    kind: number,
    source: number | null,
    destination: number,
  ): Promise<any> {
    const http = new CommonHttp();
    return http
      .post(`Analytics/Lists/Create`, {
        elementId: elementId,
        kind: kind,
        source: source,
        destination: destination,
      })
      .then((data) => data.data);
  }

  // static getListForAdd(filter: string, offset: number, segment: number, elementId: number):  Promise<any> {
  //     const store = rootStore();
  //     const http = new CommonHttp()
  //     return http
  //         .get(`Analytics/Lists?filter=${filter}&count=30&offset=${0}&segment=${segment}&elementId=${elementId}`)
  //         .then(data => data.data)
  // }
}
